import { FC } from 'react';
import clsx from 'clsx';
import { Icon } from '@kontentino/ui';
import { CreateOption } from 'components/navigation/verticalNavigation/mainMenu/createTooltipContent/CreateTooltipContent';

type Props = {
  option: CreateOption;
};

const RegularCreateOption: FC<Props> = ({ option }) => {
  return (
    <div
      onClick={option.onClick}
      data-name={`posts-add-new-${option.key}`}
      data-testid={`create-option-${option.key}`}
      className={clsx(
        'tw-group tw-flex tw-h-8 tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-md tw-px-2 tw-transition-colors hover:tw-bg-primary-10',
        {
          '!tw-bg-primary-10': option.highlighted,
        },
      )}
    >
      <Icon
        icon={option.icon}
        className={clsx(
          'tw-text-grayscale-180 group-hover:tw-text-primary-100',
          {
            '!tw-text-primary-100': option.highlighted,
          },
        )}
      />
      <span
        className={clsx(
          'tw-text-sm tw-text-grayscale-180 group-hover:tw-text-primary-100',
          {
            '!tw-text-primary-100': option.highlighted,
          },
        )}
      >
        {option.label}
      </span>
    </div>
  );
};

export default RegularCreateOption;
